import { IAcceptMerchantInvitationApiData, ICreateMerchantApiData, IPatchMerchantApiData } from "src/@types/merchant";
import axiosInstance from "../utils/axios";

function getMerchantByIdApi(id: string, pledgeTaken?: boolean) {
  let queryArray = [];
  if (pledgeTaken) queryArray.push("showHasPledged=" + pledgeTaken);
  let queryString = queryArray.length ? "?" + queryArray.join("&") : "";

  return axiosInstance
    .get(`/merchants/v1/${id}${queryString}`);
}

function getMerchantByCodeApi(code: string, pledgeTaken?: boolean) {
  let queryArray = [];
  if (pledgeTaken) queryArray.push("showHasPledged=" + pledgeTaken);
  let queryString = queryArray.length ? "?" + queryArray.join("&") : "";

  return axiosInstance
    .get(`/merchants/v1/${code}${queryString}`);
}

function patchMerchant(merchantCode: string, data: IPatchMerchantApiData) {
  return axiosInstance.patch(`/merchants/v1/${merchantCode}/`, data);
}

function createMerchantApi(data: ICreateMerchantApiData) {
  return axiosInstance.post(
    `/merchants/v1/`, JSON.stringify(data));
}

function acceptMerchantInvitationApi(merchantCode: string, data: IAcceptMerchantInvitationApiData) {
  return axiosInstance.post(
    `/merchants/v1/${merchantCode}/users/invitations/accept`, JSON.stringify(data));
}

function updateMerchantProgrammeApi(merchantCode: string, programmeCode: string, newProgrammeName: string) {
  return axiosInstance.patch(`/merchants/v1/${merchantCode}/programmes/${programmeCode}`, { name: newProgrammeName });
}

export { getMerchantByIdApi, createMerchantApi, acceptMerchantInvitationApi, getMerchantByCodeApi, updateMerchantProgrammeApi, patchMerchant };
